import { render, staticRenderFns } from "./InputTextCounter.vue?vue&type=template&id=3b6e60b9&"
import script from "./InputTextCounter.vue?vue&type=script&lang=js&"
export * from "./InputTextCounter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports